import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {ButtonAlignment, FormLayout, TextAlignment} from '../../../../../types/createStylesParams'

export enum AreasStyle {
  Cards = 'cards',
  Dropdown = 'dropdown',
}

export type LayoutSettingsParams = {
  textAlignment: SettingsParamType.String
  formLayout: SettingsParamType.String
  buttonAlignment: SettingsParamType.String
}

export const layoutSettingsParams = createSettingsParams<LayoutSettingsParams>({
  textAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Center,
  },
  formLayout: {
    type: SettingsParamType.String,
    getDefaultValue: () => FormLayout.Strip,
  },
  buttonAlignment: {
    type: SettingsParamType.String,
    inheritDesktop: false,
    getDefaultValue: (params) =>
      params.isMobile ? ButtonAlignment.Stretch : ButtonAlignment.Center,
  },
})

export type AreasLayoutSettingsParams = {
  areasStyle: SettingsParamType.String
  areasCardsAlignment: SettingsParamType.String
  areasTextAlignment: SettingsParamType.String
}

export const areasLayoutSettingsParams = createSettingsParams<AreasLayoutSettingsParams>({
  areasStyle: {
    type: SettingsParamType.String,
    getDefaultValue: () => AreasStyle.Cards,
  },
  areasCardsAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Left,
  },
  areasTextAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Left,
  },
})
